import { HtmlTemplateString } from "../types";
import { defineDirective } from "../utils/angular";
import { isUndefinedOrNull } from "../utils/utils";

const template: HtmlTemplateString = `
        <div ng-class='vm.getCssClass()'>
            <label>
                <input ng-if='!vm.indeterminate' type='checkbox' ng-model='vm.ngModel' ng-disabled='vm.disabled' ng-change='vm.onChange()'>
                <input ng-if='vm.indeterminate' type='checkbox' ng-disabled='vm.disabled' ng-click='vm.onClick()' ng-checked='vm.ngModel' ng-prop-indeterminate='vm.ngModel === null'>
                <i ng-if='vm.showIcons' ng-class='vm.getIconClass()'></i>
                <span>
                    <ng-transclude></ng-transclude>
                </span>
            </label>
        </div>`

/** @internal */
export class CheckboxCtrl {

    static create() {

        const def = defineDirective(CheckboxCtrl, null, {
            "ngModel": "=",
            "ngChange": "&",
            "disabled": "<",
            "class": "<",
            "light": "<",
            "icons": "<",
            "indeterminate": "<"
        });

        def.require = "^ngModel"
        def.transclude = true
        def.template = template

        return def

    }

    ngModel: boolean
    ngChange: Function
    light: boolean
    class: {}

    /** If true, uses Font Awesome icons for the checkbox */
    icons: boolean

    /**
     * If truthy, supports as interminate state with a value of null
     * This implies "icons" = true, and the value of "indeterminate" must be the class of the FA icon
     * to represent the indeterminate state
     */
    indeterminate: string

    animate: boolean


    static $inject = ["$timeout"]

    constructor(private $timeout: ng.ITimeoutService) {
    }

    onClick() {

        let { ngModel: checked } = this

        if (checked === false) {
            checked = true
        }
        else if (checked === true) {
            checked = null
        }
        else {
            checked = false
        }

        this.ngModel = checked
        this.onChange()

    }

    onChange() {

        this.animate = true
        this.$timeout(500).then(() => this.animate = false)

        if (this.ngChange) {
            this.$timeout(() => this.ngChange())
        }

    }

    get showIcons() {
        const { icons, indeterminate } = this
        return icons || Boolean(indeterminate)
    }

    getCssClass() {

        const { light, showIcons: icons, animate, ngModel, class: cls, indeterminate } = this
        const checked = Boolean(ngModel)

        return {
            checkbox: true,
            "checkbox-styled": !icons,
            icons,
            animate,
            checked,
            light,
            indeterminate: indeterminate && (ngModel === null),
            ...cls
        }
    }

    getIconClass() {

        const { indeterminate, ngModel: checked } = this

        return (indeterminate && isUndefinedOrNull(checked))
            ? indeterminate
            : checked
                ? "fas fa-check"
                : "far fa-square"

    }

}

